export var ShowHelp;
(function (ShowHelp) {
    ShowHelp["tooltip"] = "tooltip";
    ShowHelp["newLine"] = "newLine";
    ShowHelp["none"] = "none";
})(ShowHelp || (ShowHelp = {}));
